module.exports = __webpack_public_path__ + "static/media/iiot_background.14ab313b.png";